import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gf2-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit{

  constructor() { }

  ngOnInit() {
  }

}
